<div class=custom-input-file>
    <div *ngIf="labelText">
        <label for="inputFile" class="input-file-label" [attr.data-automation-id]="automationId + '-label'">{{labelText}}:</label>
    </div>
    <input id="inputFile" #openFileInput type="file" accept="{{typesAccepted}}"
        onclick="this.value=null;" (change)="onAccept($event)" />
    <div class="file-upload">
        <div>
            <input type="text" disabled [(ngModel)]="model.fileName" title="{{model.fileName}}"
            [attr.data-automation-id]="automationId + '-input'" class="input-file-name" />
            <button title="Remove logo" class="btn btn-secondary btn-delete" *ngIf="model.fileName"
                (click)="onRemove()" [attr.data-automation-id]="automationId + '-delete-button'">
                <i aria-hidden="true" class="fa fa-trash"></i>
            </button>
        </div>
        <button [disabled]="disabled" (click)="openFileInput.click()" class="secondary-button btn-action" [attr.data-automation-id]="automationId + '-browse-button'">
            Browse ...
        </button>
        <span *ngIf="sizeLimitInMB">{{sizeLimitInMB}}MB max.</span>
    </div>
</div>